(() => {
  const propertySelector = 'input[name^="properties["]';
  const uploadState = new WeakMap();

  const isUploadUrl = (value) =>
    typeof value === 'string' && (/cloudlift\.app/i.test(value) || /\/uploads\//i.test(value));

  const findProductForm = (target) => {
    if (!(target instanceof Element)) return null;

    const directForm = target.closest('form[action*="/cart/add"]');
    if (directForm) return directForm;

    const productArea = target.closest('.product-info, .section-product-info, [data-section-type="product"]');
    return productArea?.querySelector('form[action*="/cart/add"] [name="add"]')?.closest('form') || null;
  };

  const getUploadUrls = (form) => {
    if (!uploadState.has(form)) uploadState.set(form, new Map());
    return uploadState.get(form);
  };

  const syncOrderProperties = (form) => {
    const uploads = getUploadUrls(form);
    const urls = Array.from(uploads.values()).filter(Boolean);

    form.querySelectorAll('[data-ink-upload-order-link]').forEach((input) => input.remove());
    if (!urls.length) return;

    const nativeUrls = new Set(
      Array.from(form.querySelectorAll(propertySelector))
        .filter((input) => !input.hasAttribute('data-ink-upload-order-link') && isUploadUrl(input.value))
        .map((input) => input.value)
    );
    urls.forEach((url, index) => {
      if (nativeUrls.has(url)) return;
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = urls.length > 1 ? `properties[upload_${index + 1}]` : 'properties[upload]';
      input.value = url;
      input.setAttribute('data-ink-upload-order-link', 'true');
      form.append(input);
    });
  };

  const syncAfterAppUpdates = (form) => {
    syncOrderProperties(form);
    window.setTimeout(() => syncOrderProperties(form), 0);
    window.setTimeout(() => syncOrderProperties(form), 250);
  };

  window.addEventListener('upload:added', (event) => {
    const file = event.detail;
    if (!file?.url || file.meta?.variant === 'thumbnail') return;

    const form = findProductForm(event.target);
    if (!form) return;

    const uploadId = file.id || file.serverId || file.key || file.url;
    getUploadUrls(form).set(String(uploadId), file.url);
    syncAfterAppUpdates(form);
  });

  window.addEventListener('upload:removed', (event) => {
    const file = event.detail;
    if (file?.meta?.variant === 'thumbnail') return;
    const form = findProductForm(event.target);
    if (!form || !file) return;

    const uploads = getUploadUrls(form);
    const uploadId = file.id || file.serverId || file.key || file.url;
    uploads.delete(String(uploadId));
    if (file.url) {
      uploads.forEach((url, key) => {
        if (url === file.url) uploads.delete(key);
      });
    }
    syncAfterAppUpdates(form);
  });

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (form instanceof HTMLFormElement && form.matches('form[action*="/cart/add"]')) {
      syncOrderProperties(form);
    }
  }, true);
})();
